export const ALL_MERCHANTS = "all-merchants";
export const ALL_SUBMERCHANTS = "all-submerchants";
